import { render, staticRenderFns } from "./KougiPage.vue?vue&type=template&id=1e0a7310&"
import script from "./KougiPage.vue?vue&type=script&lang=js&"
export * from "./KougiPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports